<div class="auto-refresh-container" [class.disabled]="disabled">
    <div class="auto-refresh-controls">
        <p-select
            class="auto-refresh-dropdown"
            [options]="intervalOptions"
            [(ngModel)]="currentInterval"
            (onChange)="onIntervalChange($event)"
            [disabled]="disabled"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'Select interval'"
        ></p-select>

        @if (showRefreshButton) {
            <p-button icon="pi pi-refresh" (click)="manualRefresh()" [disabled]="disabled" [title]="'Manual refresh'" />
        }
    </div>
</div>
